/**
 * AlmadarPostSoftwareThatSharesSLAlmadarPostSoftwareThatSharesSLPage
 *
 * Page component for AlmadarPostSoftwareThatSharesSLAlmadarPostSoftwareThatSharesSLPage
 * Path: /sl/blog/software-that-shares
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostSoftwareThatSharesSLPostPageView as __AlmadarPostSoftwareThatSharesSLPostPageView } from '@/components/traits/AlmadarPostSoftwareThatSharesSLPostPageView';
import { AlmadarPostSoftwareThatSharesSLPostAnalyticsView as __AlmadarPostSoftwareThatSharesSLPostAnalyticsView } from '@/components/traits/AlmadarPostSoftwareThatSharesSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostSoftwareThatSharesSLAlmadarPostSoftwareThatSharesSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostSoftwareThatSharesSLAlmadarPostSoftwareThatSharesSLPage(_props: AlmadarPostSoftwareThatSharesSLAlmadarPostSoftwareThatSharesSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostSoftwareThatSharesSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostSoftwareThatSharesSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostSoftwareThatSharesSLAlmadarPostSoftwareThatSharesSLPage;
